/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: constants.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Constants for Branding module.
────────────────────────────────────────────────────────────────*/

import type { BrandingImageField } from './types';

export const IMAGE_FIELDS: BrandingImageField[] = [
  'logo',
  'logoDark',
  'mobileLogo',
  'mobileLogoDark',
  'favicon',
  'faviconDark',
  'loginBackgroundImage',
  'loginLogo',
];

